<template>
  <div class="widget-user-information alert alert-info">
    <div class="latest_register hidden">
      <h2>สมาชิกล่าสุด</h2>
      <ul>
        <li v-for="(user, i) in content.latest_register" :key="'user' + i">
          <div class="text-username pull-left" v-html="renderSome(user.username)"></div> สมัคร {{ user.created_at | timeago }}
        </li>
      </ul>
      <template v-if="showPromotion && promotionAmount > 0">
        <h2>โปรโมชั่นสมัครสมาชิก</h2>
        <ul>
          <li v-for="(promotion, i) in content.promotion_balance" v-if="promotion.balance > 0" :key="'pro' + i">
            {{ promotion.title }} คงเหลือ
            <span
              class="badge"
              :class="{ 'badge-success' : promotion.balance > 0, 'badge-danger' : promotion.balance <= 0 }">
              {{ promotion.balance }}
            </span>
          </li>
        </ul>
      </template>
    </div>
    <div class="row">
      <div class="widget-realtime">
        <div class="col-md-6 text-center">
          <h3>สมาชิกปัจจุบัน</h3>
          <div class="big-number">{{ content.total_members | number }}</div>
        </div>
        <div class="col-md-6 text-center">
          <h3>กำลังเล่นเกมส์</h3>
          <div class="big-number">{{ content.total_online }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import _ from 'lodash'
  import moment from 'moment'
  export default {
    name: 'member-information',
    props: {
      masterUserId: {
        type: [String, Number],
        default: ''
      },
      agentUserId: {
        type: [String, Number],
        default: ''
      },
      showPromotion: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        content: {}
      }
    },
    computed: {
      promotionAmount () {
        const promotions = _.get(this.content, 'promotion_balance')
        return _.sumBy(promotions, 'balance')
      }
    },
    mounted () {
      moment.locale(window.currentLang)
      axios.get(`/information/publish?master_user_id=${this.masterUserId}&agent_user_id=${this.agentUserId}`)
        .then(resp => {
          this.content = resp.data
        })
    },
    methods: {
      renderSome (username) {
        return username.replace('xxx', '<span class="hidden-some text-danger">xxx</span>')
      }
    },
    filters: {
      timeago (time) {
        return moment(time, ['MM/DD/YYYY HH:mm:ss']).fromNow()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/MemberInformation.vue